interface Role {
  org: string;
  title: string;
  period: string;
  location: string;
  bullets: string[];
  tags: { label: string; colour?: string }[];
}

const roles: Role[] = [
  {
    org: 'Shree Krishna Temple',
    title: 'Lead Project Manager & Software Engineer',
    period: 'Aug 2025 - Present',
    location: 'Coventry',
    bullets: [
      'Led end-to-end delivery of a secure, GDPR-compliant self-checkout donation kiosk and POS platform, replacing a fully manual process with a scalable live production system.',
      'Directly line-managed 7 developers and testers across Agile/Scrum sprint cycles, owning the full applications function from delivery through post-deployment support.',
      'Built an AI-powered admin dashboard for real-time payment analytics and ran ITIL-aligned change and problem management throughout the project lifecycle.'
    ],
    tags: [
      { label: 'PHP' },
      { label: 'Agile & Scrum', colour: 'pink' },
      { label: 'GDPR', colour: 'red' },
      { label: 'ITIL', colour: 'grey' },
      { label: 'Supplier Management', colour: 'grey' }
    ]
  },
  {
    org: 'Leicestershire County Council',
    title: 'Placement Technical Specialist',
    period: 'Aug 2024 - Aug 2025',
    location: 'Leicestershire',
    bullets: [
      'Designed, built and maintained Drupal-based council websites to WCAG 2.1 AA accessibility standards, and delivered multi-stage digital forms and workflows on Granicus.',
      'Engineered AI-powered chatbots for public-facing services and internal developer support, applying GDPR and GDS-aligned AI governance principles throughout.',
      'Contributed to a 50% statutory SLA improvement on the SENA programme; produced Power BI dashboards and administered Microsoft 365 and Azure across Housing, Adult Social Care and Children’s Services.'
    ],
    tags: [
      { label: 'Drupal' },
      { label: 'WCAG 2.1 AA', colour: 'turquoise' },
      { label: 'GDS Standards' },
      { label: 'Power BI', colour: 'yellow' },
      { label: 'Azure' },
      { label: 'Power Platform', colour: 'grey' }
    ]
  },
  {
    org: 'Leicester Literary & Philosophical Society',
    title: 'Technical Specialist',
    period: 'Sep 2025 - Jun 2026',
    location: 'Leicester',
    bullets: [
      'Modernised workflows and digital administration using Microsoft 365 and the Power Platform, improving compliant, accessible management of member data.',
      'Provided AV, hybrid-streaming and IT support for lectures and events, and recorded/broadcast content to widen accessibility for members and audiences.'
    ],
    tags: [
      { label: 'Microsoft 365', colour: 'grey' },
      { label: 'Power Platform', colour: 'grey' },
      { label: 'Accessibility', colour: 'turquoise' }
    ]
  },
  {
    org: 'De Montfort University',
    title: 'Student Ambassador',
    period: 'Apr 2023 - Present',
    location: 'Leicestershire',
    bullets: [
      'Represented the university at UCAS fairs and widening-participation events, and acted as first point of contact for international students and campus tours.',
      'Delivered presentations to diverse audiences and supported faculty staff at departmental events.'
    ],
    tags: [
      { label: 'Stakeholder Engagement', colour: 'grey' },
      { label: 'Public Speaking', colour: 'grey' }
    ]
  }
];

const education = [
  {
    title: 'BSc Computer Science (with Placement Year)',
    org: 'De Montfort University',
    period: 'Jan 2023 - Jun 2026 · Predicted First Class'
  },
  {
    title: 'PRINCE2 Certification',
    org: 'Project Management',
    period: 'Certified practitioner'
  }
];

export default function Experience() {
  return (
    <div id="experience" className="app-section--dark govuk-!-padding-top-8 govuk-!-padding-bottom-8">
      <div className="govuk-width-container">
        <h2 className="govuk-heading-l govuk-!-margin-bottom-6">Experience & delivery</h2>

        <div className="app-timeline">
          {roles.map((role) => (
            <div key={role.org + role.title} className="app-timeline__item">
              <p className="govuk-body-s govuk-!-margin-bottom-1" style={{ color: '#b1b4b6' }}>
                {role.period} &middot; {role.location}
              </p>
              <h3 className="govuk-heading-m govuk-!-margin-bottom-1">{role.title}</h3>
              <p className="govuk-body govuk-!-font-weight-bold govuk-!-margin-bottom-3">{role.org}</p>
              <ul className="govuk-list govuk-list--bullet">
                {role.bullets.map((b) => (
                  <li key={b}>{b}</li>
                ))}
              </ul>
              <p>
                {role.tags.map((tag) => (
                  <strong
                    key={tag.label}
                    className={`govuk-tag${tag.colour ? ` govuk-tag--${tag.colour}` : ''} govuk-!-margin-right-1 govuk-!-margin-bottom-1`}
                  >
                    {tag.label}
                  </strong>
                ))}
              </p>
            </div>
          ))}
        </div>

        <h2 className="govuk-heading-l govuk-!-margin-top-8 govuk-!-margin-bottom-6">
          Education & certifications
        </h2>
        <div className="govuk-grid-row">
          {education.map((e) => (
            <div key={e.title} className="govuk-grid-column-one-half">
              <div className="govuk-!-padding-4" style={{ background: '#1e1e1e', height: '100%' }}>
                <h3 className="govuk-heading-s govuk-!-margin-bottom-1">{e.title}</h3>
                <p className="govuk-body-s govuk-!-margin-bottom-1" style={{ color: '#b1b4b6' }}>{e.org}</p>
                <p className="govuk-body-s govuk-!-margin-bottom-0">{e.period}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
